module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"gender_rate":"Gender Rate","gender_desc":"Displays the gender ratio of customers who visit the store."}}')
  delete Component.options._Ctor
}
